import { gql } from '@apollo/client'

export const LOG_MUTATION = gql`
  mutation Log($data: [logactivite_insert_input!]!) {
    insert_logactivite(objects: $data) {
      affected_rows
    }
  }
`
